import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateJustificationActions } from "store/ducks/settings/justifications";

export function* createJustificationRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/justifications`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateJustificationActions.success(data));
    notify("success", "Justificativa cadastrada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateJustificationActions.failure(errorMessage));
  }
}
